export default class Laboratory {
  constructor(id, name, country, createdDate, active, configuration) {
    this.id = id;
    this.name = name;
    this.country = country;
    this.createdDate = createdDate;
    this.active = active;
    this.configuration = configuration;
  }

  static build({ id, name, country, createdDate, active, configuration }) {
    return new Laboratory(id, name, country, createdDate, active, configuration);
  }

  static parse(value) {
    return value ? Laboratory.build({
      id: value.id,
      name: value.name,
      country: value.country,
      createdDate: value.createdDate,
      active: value.active,
      configuration: value.configuration
    }) : null;
  }

  toJSON() {
    return {
      id: this.id !== undefined || this.id !== '' ? this.id : null,
      name: this.name !== undefined || this.name !== '' ? this.name : null,
      country: this.country !== undefined ? this.country : null,
      createdDate: this.createdDate !== undefined ? this.createdDate : null,
      active: this.active !== undefined ? this.active : null,
      configuration: this.configuration !== undefined ? this.configuration : null
    };
  }
}
